module.exports = __webpack_public_path__ + "img/cross.53635739.svg";